
const configuration = {
  playerSiteData: {
    "id": "flumotion-player",
    "vjsFlashPath": "//player.flumotion.com/video-js.swf",
    "autoplay": false,
    "loop": false,
    "muted": false,
    "volume": 1.0,
    "skin": {
      "skin": "modern-skin",
      "primaryColor": "#EEEEEEFF",
      "secondaryColor": "#999999FF",
      "backgroundColor": "#333333FF",
      "borderRadius": "1.0em"
    },
    "branding": {},
    "crossoriginDomain": null,
    "share": null,
    "panorama": false,
    "controls": true,
    "aspectRatio": "16:9",
    "width": "100%",
    "height": 440,
    "techOrder": [
      "html5",
      "flash"
    ],
    "preload": "auto",
    "download": false,
    "inactivityTimeout": 0,
    "dvr": false,
    "startAt": null,
    "alternateContent": null,
    "reduceLiveDelay": false,
    "displayTitle": false,
    "showChaptersButton": false,
    "showChapterMarkers": false,
    "smallAudioPlayer": false,
    "forward": false,
    "backward": false,
    "playbackSpeeds": null,
    "disableContextMenu": false,
    "disableShareLink": false,
    "disableShareEmbed": false,
    "detectBandwidth": false,
    "title": "",
    "type": "video",
    "advertisement": null,
    "sources": [{
        "file": "https://error",
    }],
    "captions": [],
    "chapters": [],
    "downloadableSrc": null,
    "visualSeeking": "",
    "poster": "",
    "thumbnail": "",
    "realtimeStats": {},
    "relatedContent": null,
    "statistics": {},
  },
  
  contextmenuUI: [{
    'href': 'http://www.flumotion.com/', 'label': 'About Flumotion',
  }],
}
  
export default configuration;
  